<div class="navigation">
  <a [routerLink]="[homeRoute]" style="text-decoration: none">
    <h3>AV.Park</h3>
  </a>
  <div *ngIf="envInfo" class="d-flex mb-3 center">
      <div class="navbar-brand" ngClass="{{envInfo}}">{{envInfo}}</div>
  </div>

  <div class="d-flex mb-3">

    <app-language-selector></app-language-selector>
    <button class="user-btn" ejs-dropdownbutton
          *ngIf="authService.isUserLoggedIn()"
          [items]="userNavigation"
          [content]="authService.getUserInfo() ? '\<span class=\'user-name\'>' + authService.getUserInfo().firstname + ' ' + authService.getUserInfo().lastname + '\</span>': ''"
          [iconCss]="userIcon"
          (select)="onSelection($event)"></button>
  </div>

  <ejs-accordion *ngIf="authService.isUserLoggedIn()" (created)="onAccordionCreated()" class="mb-3">
    <e-accordionitems>

      <e-accordionitem>
        <ng-template #header>
          <a [routerLinkActive]="['active']" [routerLink]="[homeRoute]">
            {{ 'i18n.core.navigation.home' | translate }}
          </a>
        </ng-template>
      </e-accordionitem>

      <e-accordionitem id="{{adminSectionId}}" [visible]="authService.isUserAdminOrClientAdminOrCompanyAdmin()">
        <ng-template #header>
          <div>{{ 'i18n.core.navigation.admin' | translate }}</div>
        </ng-template>
        <ng-template #content>
          <a *ngIf="authService.isUserAdmin()" [routerLinkActive]="['active']" [routerLink]="[clientAdministrationRoute]">
            {{ 'i18n.core.navigation.client-administration' | translate }}
          </a>
          <a *ngIf="authService.isUserAdminOrClientAdmin()" [routerLinkActive]="['active']" [routerLink]="[userManagementRoute]">
            {{ 'i18n.core.navigation.user-management' | translate }}
          </a>
          <a *ngIf="authService.isUserAdminOrClientAdmin()" [routerLinkActive]="['active']" [routerLink]="[configurationAdministrationRoute]">
            {{ 'i18n.core.navigation.configuration-administration' | translate }}
          </a>
          <a *ngIf="authService.isUserAdminOrClientAdmin()" [routerLinkActive]="['active']" [routerLink]="[companyAdministrationRoute]">
            {{ 'i18n.core.navigation.company-administration' | translate }}
          </a>
          <a [routerLinkActive]="['active']" [routerLink]="[parkerAdministrationRoute]">
            {{ 'i18n.core.navigation.parker-administration' | translate }}
          </a>
          <a [routerLinkActive]="['active']" [routerLink]="[fleetListAdministrationRoute]">
            {{ 'i18n.core.navigation.fleet-list' | translate }}
          </a>
          <a [routerLinkActive]="['active']" [routerLink]="[tagsAdministrationRoute]">
            {{ 'i18n.core.navigation.tags-administration' | translate }}
          </a>
          <!-- <a *ngIf="authService.isUserAdminOrClientAdmin()" [routerLinkActive]="['active']" [routerLink]="[onBoardingWizardRoute]">
            {{ 'i18n.core.navigation.onboarding-wizard' | translate }}
          </a> -->
          <a *ngIf="authService.isUserAdminOrClientAdmin()" [routerLinkActive]="['active']" [routerLink]="[tagMasterRoute]">
            {{ 'i18n.core.navigation.tag-master' | translate }}
          </a>
          <a *ngIf="authService.isUserAdmin()" [routerLinkActive]="['active']" [routerLink]="[thirdPartyUserZoneAssignmentAdministrationRoute]">
            {{ 'i18n.core.navigation.third-party-user-assignment-administration' | translate }}
          </a>
        </ng-template>
      </e-accordionitem>

      <e-accordionitem id="{{parkingSectionId}}"
                       [visible]="authService.isUserAdminOrClientAdminOrCompanyAdmin() || authService.isUserStandardUser()">
        <ng-template #header>
          <div >{{ 'i18n.core.navigation.parking' | translate }}</div>
        </ng-template>
        <ng-template #content>
          <a *ngIf="authService.isUserStandardUser() && hasActiveClient" [routerLinkActive]="['active']" [routerLink]="[parkingRoute]">
            {{ 'i18n.core.navigation.parking' | translate }}
          </a>
          <a *ngIf="authService.isUserStandardUser() && hasActiveClient && hasAutomaticParking" [routerLinkActive]="['active']" [routerLink]="[automaticParkingRoute]">
            {{ 'i18n.core.navigation.automatic-parking' | translate }}
          </a>
          <a *ngIf="authService.isUserAdminOrClientAdminOrCompanyAdmin()" [routerLinkActive]="['active']" [routerLink]="[parkerRegistrationRoute]">
            {{ 'i18n.core.navigation.parker-registrations' | translate }}
          </a>
          <a *ngIf="authService.isUserAdminOrClientAdmin()" [routerLinkActive]="['active']" [routerLink]="[parkingRangerSessionsRoute]">
            {{ 'i18n.core.navigation.parking-ranger-sessions' | translate }}
          </a>
          <a *ngIf="authService.isUserAdminOrClientAdmin()" [routerLinkActive]="['active']" [routerLink]="[zoneDamageRoute]">
            {{ 'i18n.core.navigation.zone-damage' | translate }}
          </a>
          <a *ngIf="authService.isUserAdminOrClientAdmin()" [routerLinkActive]="['active']" [routerLink]="[deviceInteraction]">
            {{ 'i18n.core.navigation.device-interaction' | translate }}
          </a>
          <a *ngIf="authService.isUserStandardUser() || authService.isUserAdminOrClientAdminOrCompanyAdmin()" [routerLinkActive]="['active']" [routerLink]="[parkingCardRoute]">
            {{ 'i18n.core.navigation.parking-card' | translate }}
          </a>
        </ng-template>
      </e-accordionitem>

      <e-accordionitem id="{{reportsSectionId}}">
        <ng-template #header>
          <div >{{ 'i18n.core.navigation.reports' | translate }}</div>
        </ng-template>
        <ng-template #content>
          <a [routerLinkActive]="['active']" [routerLink]="[savedReportsRoute]">
            {{ 'i18n.core.navigation.reports' | translate }}
          </a>
          <a *ngIf="authService.isUserAdminOrClientAdmin()" [routerLinkActive]="['active']" [routerLink]="[exportJobsRoute]">
            {{ 'i18n.core.navigation.export-jobs' | translate }}
          </a>
          <a *ngIf="canUserSeeReport(ReportType.TagsPerParker)" [routerLinkActive]="['active']" [routerLink]="[tagsPerParkerReportRoute]">
            {{ 'i18n.shared.reportTypes.TagsPerParker' | translate }}
          </a>
          <a *ngIf="canUserSeeReport(ReportType.ParkerRegistrations)" [routerLinkActive]="['active']" [routerLink]="[parkerRegistrationsReportRoute]">
            {{ 'i18n.shared.reportTypes.ParkerRegistrations' | translate }}
          </a>
          <a *ngIf="canUserSeeReport(ReportType.FalseRecordings)" [routerLinkActive]="['active']" [routerLink]="[falseRecordingsReportRoute]">
            {{ 'i18n.shared.reportTypes.FalseRecordings' | translate }}
          </a>
          <a *ngIf="canUserSeeReport(ReportType.ParkerTurnover)" [routerLinkActive]="['active']" [routerLink]="[parkerTurnoverReportRoute]">
            {{ 'i18n.shared.reportTypes.ParkerTurnover' | translate }}
          </a>
          <a *ngIf="canUserSeeReport(ReportType.ParkerExtract)" [routerLinkActive]="['active']" [routerLink]="[parkerExtractReportRoute]">
            {{ 'i18n.shared.reportTypes.ParkerExtract' | translate }}
          </a>
          <a *ngIf="canUserSeeReport(ReportType.DeviceStatus)" [routerLinkActive]="['active']" [routerLink]="[deviceStatusReportRoute]">
            {{ 'i18n.shared.reportTypes.DeviceStatus' | translate }}
          </a>
          <a *ngIf="canUserSeeReport(ReportType.AutomaticParking)" [routerLinkActive]="['active']" [routerLink]="[automaticParkingReportRoute]">
            {{ 'i18n.shared.reportTypes.AutomaticParking' | translate }}
          </a>
          <a *ngIf="canUserSeeReport(ReportType.Payment)" [routerLinkActive]="['active']" [routerLink]="[paymentReportRoute]">
            {{ 'i18n.shared.reportTypes.Payment' | translate }}
          </a>
          <a *ngIf="canUserSeeReport(ReportType.UserExtract)" [routerLinkActive]="['active']" [routerLink]="[userExtractReportRoute]">
            {{ 'i18n.shared.reportTypes.UserExtract' | translate }}
          </a>
        </ng-template>
      </e-accordionitem>

    </e-accordionitems>
  </ejs-accordion>

  <div class="d-flex mb-3 center">
    <app-parking-indicator *ngIf="authService.isUserLoggedIn()"></app-parking-indicator>
  </div>
</div>
